import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, Users, DollarSign, Calendar, Download, ArrowLeft, Activity, Award } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
export function AdminAnalytics() {
  const navigate = useNavigate();
  const [period, setPeriod] = useState('monthly');
  const stats = [{
    label: 'Total Pendapatan',
    value: 'Rp 150 Juta',
    trend: '+15%',
    icon: DollarSign,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Anggota Baru',
    value: '234',
    trend: '+12%',
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Acara Terselenggara',
    value: '48',
    trend: '+8%',
    icon: Calendar,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Tingkat Pertumbuhan',
    value: '23%',
    trend: '+5%',
    icon: TrendingUp,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const membershipBreakdown = [{
    type: 'Individu Pelajar',
    count: 1245,
    percentage: 51,
    color: 'bg-atios-primary'
  }, {
    type: 'Individu Umum',
    count: 856,
    percentage: 35,
    color: 'bg-success'
  }, {
    type: 'Organisasi',
    count: 234,
    percentage: 10,
    color: 'bg-warning'
  }, {
    type: 'Badan Usaha',
    count: 115,
    percentage: 4,
    color: 'bg-error'
  }];
  const chapterStats = [{
    name: 'Jakarta Tech Community',
    members: 456,
    growth: '+15%'
  }, {
    name: 'Bandung Dev Community',
    members: 312,
    growth: '+12%'
  }, {
    name: 'Surabaya Tech Hub',
    members: 289,
    growth: '+8%'
  }, {
    name: 'Yogyakarta Digital',
    members: 234,
    growth: '+10%'
  }];
  const handleExport = () => {
    alert('Mengekspor laporan analitik...');
  };
  return <div className="min-h-screen bg-white" data-id="element-492">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-493">
        {/* Header */}
        <div className="mb-8" data-id="element-494">
          <Button variant="ghost" onClick={() => navigate('/admin/dashboard')} className="mb-4" data-id="element-495">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-496" />
            Kembali ke Dasbor
          </Button>
          <div className="flex items-center justify-between" data-id="element-497">
            <div data-id="element-498">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-499">
                Analitik Sistem
              </h1>
              <p className="text-neutral-600" data-id="element-500">
                Analitik dan insight seluruh sistem
              </p>
            </div>
            <Button variant="secondary" onClick={handleExport} data-id="element-501">
              <Download className="w-4 h-4 mr-2" data-id="element-502" />
              Export Laporan
            </Button>
          </div>
        </div>

        {/* Period Filter */}
        <div className="mb-6" data-id="element-503">
          <div className="flex gap-2" data-id="element-504">
            <Button variant={period === 'daily' ? 'primary' : 'secondary'} onClick={() => setPeriod('daily')} data-id="element-505">
              Harian
            </Button>
            <Button variant={period === 'weekly' ? 'primary' : 'secondary'} onClick={() => setPeriod('weekly')} data-id="element-506">
              Mingguan
            </Button>
            <Button variant={period === 'monthly' ? 'primary' : 'secondary'} onClick={() => setPeriod('monthly')} data-id="element-507">
              Bulanan
            </Button>
            <Button variant={period === 'yearly' ? 'primary' : 'secondary'} onClick={() => setPeriod('yearly')} data-id="element-508">
              Tahunan
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-509">
          {stats.map((stat, i) => <Card key={i} data-id="element-510">
              <CardContent className="p-6" data-id="element-511">
                <div className="flex items-center justify-between mb-4" data-id="element-512">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-513">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-514" />
                  </div>
                  <span className="text-sm text-success font-medium" data-id="element-515">
                    {stat.trend}
                  </span>
                </div>
                <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-516">
                  {stat.value}
                </h3>
                <p className="text-sm text-neutral-600" data-id="element-517">{stat.label}</p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-518">
          {/* Membership Breakdown */}
          <Card data-id="element-519">
            <CardHeader data-id="element-520">
              <CardTitle data-id="element-521">Komposisi Keanggotaan</CardTitle>
            </CardHeader>
            <CardContent data-id="element-522">
              <div className="space-y-4" data-id="element-523">
                {membershipBreakdown.map((item, i) => <div key={i} data-id="element-524">
                    <div className="flex items-center justify-between mb-2" data-id="element-525">
                      <span className="text-sm font-medium text-neutral-900" data-id="element-526">
                        {item.type}
                      </span>
                      <span className="text-sm text-neutral-600" data-id="element-527">
                        {item.count} ({item.percentage}%)
                      </span>
                    </div>
                    <div className="w-full bg-neutral-100 rounded-full h-2" data-id="element-528">
                      <div className={`${item.color} h-2 rounded-full transition-all`} style={{
                    width: `${item.percentage}%`
                  }} data-id="element-529" />
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Top Chapters */}
          <Card data-id="element-530">
            <CardHeader data-id="element-531">
              <CardTitle data-id="element-532">Chapter Teratas</CardTitle>
            </CardHeader>
            <CardContent data-id="element-533">
              <div className="space-y-4" data-id="element-534">
                {chapterStats.map((chapter, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-535">
                    <div data-id="element-536">
                      <p className="font-medium text-neutral-900" data-id="element-537">
                        {chapter.name}
                      </p>
                      <p className="text-sm text-neutral-600" data-id="element-538">
                        {chapter.members} anggota
                      </p>
                    </div>
                    <Badge variant="success" data-id="element-539">{chapter.growth}</Badge>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-540">
          <Card data-id="element-541">
            <CardHeader data-id="element-542">
              <CardTitle data-id="element-543">Pertumbuhan Anggota</CardTitle>
            </CardHeader>
            <CardContent data-id="element-544">
              <div className="h-64 flex items-center justify-center bg-neutral-50 rounded-lg border border-neutral-200" data-id="element-545">
                <div className="text-center" data-id="element-546">
                  <Activity className="w-12 h-12 text-neutral-300 mx-auto mb-2" data-id="element-547" />
                  <p className="text-sm text-neutral-500" data-id="element-548">
                    Grafik Pertumbuhan Anggota
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-549">
            <CardHeader data-id="element-550">
              <CardTitle data-id="element-551">Tren Pendapatan</CardTitle>
            </CardHeader>
            <CardContent data-id="element-552">
              <div className="h-64 flex items-center justify-center bg-neutral-50 rounded-lg border border-neutral-200" data-id="element-553">
                <div className="text-center" data-id="element-554">
                  <DollarSign className="w-12 h-12 text-neutral-300 mx-auto mb-2" data-id="element-555" />
                  <p className="text-sm text-neutral-500" data-id="element-556">
                    Grafik Pendapatan per Bulan
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
}